import { render } from "./AppProfile.vue?vue&type=template&id=36e94845&scoped=true"
import script from "./AppProfile.vue?vue&type=script&lang=js"
export * from "./AppProfile.vue?vue&type=script&lang=js"

import "./AppProfile.vue?vue&type=style&index=0&id=36e94845&lang=scss&scoped=true"

import exportComponent from "/Users/coolio/Documents/proyectos/karga/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e94845"]])

export default __exports__